import { BeachVolleyballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const PointPopup = new PopupBuilder('Point', {
  incident_id: BeachVolleyballIncidentId.Point,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
